var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C12.663 13.5 13.2989 13.2366 13.7678 12.7678C14.2366 12.2989 14.5 11.663 14.5 11C14.5 10.337 14.2366 9.70107 13.7678 9.23223C13.2989 8.76339 12.663 8.5 12 8.5C11.337 8.5 10.7011 8.76339 10.2322 9.23223C9.76339 9.70107 9.5 10.337 9.5 11C9.5 11.663 9.76339 12.2989 10.2322 12.7678C10.7011 13.2366 11.337 13.5 12 13.5Z",
    fill: "#84693B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 3.42899H19.072C22.977 7.33399 22.977 13.666 19.072 17.571L13.669 22.974C13.2264 23.4161 12.6265 23.6644 12.001 23.6644C11.3754 23.6644 10.7755 23.4161 10.333 22.974L4.95797 17.599L4.92997 17.571C1.02497 13.666 1.02497 7.33399 4.92997 3.42899C8.83397 -0.476006 15.166 -0.476006 19.071 3.42899ZM5.98997 4.48899C4.39616 6.08302 3.50079 8.24585 3.50079 10.5C3.50079 12.7541 4.39616 14.916 5.98997 16.51L6.01297 16.534L6.01497 16.536L11.393 21.914C11.554 22.0748 11.7723 22.1652 12 22.1652C12.2276 22.1652 12.4459 22.0748 12.607 21.914L18.01 16.51C19.585 14.9121 20.4643 12.7563 20.4563 10.5126C20.4482 8.269 19.5534 6.11956 17.967 4.53299C16.3805 2.94643 14.2312 2.05145 11.9875 2.04321C9.74391 2.03496 7.58802 2.91413 5.98997 4.48899Z",
    fill: "#84693B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a34446a2f4b8b7cbe31485b85d65e374.svg";
export { ForwardRef as ReactComponent };